module.exports = __webpack_public_path__ + "img/fourth-plate.b68daf77.png";